import { createSlice } from "@reduxjs/toolkit";
import { getSevenALoadingDetails } from "../thunk/chart.thunk";

const initialState = {
  tempData: [],
  loading: false,
  error: null,
  railRoadObj: {
    railRoad: null,
    fyTotal: null,
    visibleTable: {},
  },
};

const chartSlice = createSlice({
  name: "chart",
  initialState,
  reducers: {
    // Example of normal reducer
    resetChartState: (state) => {
      state.tempData = [];
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSevenALoadingDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getSevenALoadingDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.tempData = action.payload;
      })

      .addCase(getSevenALoadingDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export const { resetChartState } = chartSlice.actions;
export default chartSlice.reducer;
